import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-anexar-imagens-label',
  templateUrl: './anexar-imagens-label.component.html',
  styleUrls: ['./anexar-imagens-label.component.scss']
})
export class AnexarImagensLabelComponent {

  @Input() possuiImagens = false;
  @Input() habilitarAnexarAlterarImagem = false;

  changeButtonAnexarName() {
    if (this.habilitarAnexarAlterarImagem && this.possuiImagens) {
      return 'Anexar/Visualizar';
    }

    if (this.habilitarAnexarAlterarImagem === false) {
      return 'Visualizar';
    }

    return 'Anexar';
  }

  changeIconAnexar() {
    if (this.habilitarAnexarAlterarImagem && this.possuiImagens) {
      return 'assets/images/icons/bt-visualizar-imgs.png';
    }

    if (this.habilitarAnexarAlterarImagem === false) {
      return 'assets/images/icons/bt-visualizar-imgs.png';
    }

    return 'assets/images/icons/ic-add-imgs.png';

  }
}



// WEBPACK FOOTER //
// ./src/app/components/anexar-imagens-label/anexar-imagens-label.component.ts